import React from "react";
import { useLocation } from "react-router-dom";
import "./footer.css";

const WHATSAPP_CHANNEL_URL =
  "https://whatsapp.com/channel/0029VbBq2Y37T8bRuLk5rv44";

const Footer = () => {
  const anoAtual = new Date().getFullYear();
  const location = useLocation();

  // 🔹 rotas
  const isHome = location.pathname === "/";
  const isLogin = location.pathname === "/login";
  const isResetPass = location.pathname === "/redefinir-senha";

  // 🔹 CTA WhatsApp só aparece fora dessas rotas
  const mostrarWhatsappCTA = !isHome && !isLogin && !isResetPass;

  return (
    <footer className="footer">
      <div className="footer-conteudo">

        {/* TEXTO BASE */}
        <p className="footer-copy">
          &copy; {anoAtual} NutriFácil — Todos os direitos reservados.
        </p>

        <p className="footer-sub">
          Nutrição inteligente para simplificar sua rotina.
        </p>

        {/* CTA WHATSAPP — CONDICIONAL */}
        {mostrarWhatsappCTA && (
          <div className="footer-whatsapp">
            <a
              href={WHATSAPP_CHANNEL_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="footer-whatsapp-btn"
            >
              Entrar no canal oficial do WhatsApp
            </a>

            <span className="footer-whatsapp-sub">
              Avisos importantes, novidades e ofertas exclusivas
            </span>
          </div>
        )}

        {/* LINKS JURÍDICOS — APENAS HOME */}
        {isHome && (
          <div className="footer-links">
            <a href="/politica-de-privacidade">Política de Privacidade</a>
            <a href="/termos-de-uso">Termos de Uso</a>
          </div>
        )}
      </div>
    </footer>
  );
};

export default Footer;
